import store from "@/store";
import l10n from "@/services/l10n";
import AccessControl from "@/services/AccessControl";

import { USER_GROUP_PERSON, USER_GROUP_ARTIST } from "@/constants";

export default [
  {
    name: "profile",
    path: "/profile",
    meta: { title: l10n("MY_MUSIC") },
    beforeEnter: AccessControl.route(USER_GROUP_ARTIST),
    component: () =>
      import(/* webpackChunkName: "profile" */ "@/pages/User/Profile.vue")
  },
  {
    name: "favorites",
    path: "/favorites",
    icon: "favorites",
    meta: { title: l10n("I_LIKE") },
    beforeEnter: AccessControl.route(USER_GROUP_PERSON),
    component: () =>
      import(/* webpackChunkName: "showcase" */ "@/pages/User/Favorites.vue")
  },
  {
    name: "profileEdit",
    path: "/profile/edit",
    meta: { title: l10n("EDIT_PROFILE") },
    beforeEnter: AccessControl.route(USER_GROUP_ARTIST),
    component: () =>
      import(/* webpackChunkName: "editor" */ "@/pages/User/ProfileEdit.vue")
  },
  {
    name: "logout",
    path: "/logout",
    beforeEnter: AccessControl.route(USER_GROUP_PERSON),
    component: () =>
      import(/* webpackChunkName: "logout" */ "@/pages/User/Logout.vue")
  },
  {
    name: "verify",
    path: "/verify",
    beforeEnter: async (to, from, next) => {
      await store.dispatch("user/verify", to.query.token);
      next("/");
    }
  },
  {
    name: "passwordReset",
    path: "/password/reset",
    beforeEnter: (to, from, next) => {
      const { token, email } = to.query;

      if (token && email) {
        store.dispatch("user/setPasswordResetData", { token, email });
      }

      setTimeout(() => {
        next("/");
      }, 1000);
    }
  }
];
